/* eslint-disable max-len */
import React, { useState } from 'react';
import { func, object, string, bool, arrayOf, objectOf, any } from 'prop-types';
import { connect } from 'react-redux';
import size from 'lodash/size';
import get from 'lodash/get';
import Notification from '../../atoms/stock-notifications';

import { slugify } from '../../../helpers/utils';
import { getSubscriptions, getWatchlist } from '../../../helpers/piano-helpers';
import { addEntityToFirebase } from '../../../../isomorphic/stockslist-api';
import {
  BQ_STOCK_NOTIFICATIONS_DISABLE,
  BQ_STOCK_NOTIFICATIONS_SET,
  SHOW_LOADER,
  REMOVE_LOADER,
  BQ_STOCK_WATCHLIST_GET,
  BQ_STOCK_ALREADY_ADDED,
  BQ_ENTITY_WATCHLIST_ADD_FROM_STORY,
  BQ_NOTIFICATION_LIST,
} from '../../../../store/actions';

import './market-box.module.css';
import SvgIcon from '../../atoms/svg-icon';
// import UserModal from '../../molecules/user-modal';

const getAllDirClassName = (val, upClass = '', downClass = '', defaultClass = '') => {
  if (val > 0) return upClass;
  if (val < 0) return downClass;
  return defaultClass;
};

const Tile = ({ item, checkUserLoggedIn, stockNotification, stockStatus, failure, loggedIn }) => {
  const stockName = item.type !== 'stock' ? item.name : item.nseCode || item.alias || item.name;
  const entityRedirect =
    item.type !== 'stock' ? '/markets' : `/stock/${item.stockId}/${slugify(item.name)}`;
  const tileClass =
    item.name === 'Dollar - Rupee'
      ? getAllDirClassName(item.chg, 'negative', 'positive')
      : getAllDirClassName(item.chg, 'positive', 'negative');
  const [bookmarked, setBookmarked] = useState(false);
  return (
    <>
      <div styleName={`tile ${tileClass}`}>
        <a href={entityRedirect}>
          <div>
            <span className="truncate-overflow">{stockName}</span>
            {item.value ? (
              <span style={{ color: item.chgp > 0 ? 'var(--success-color)' : 'var(--fail-color)' }}>
                {Number(item.value).toFixed(2)}
                <SvgIcon
                  type={`${item.chgp > 0 ? 'upArrowCircle' : 'downArrowCircle'}`}
                  source="image"
                  height="13"
                  width="13"
                />
              </span>
            ) : (
              '-'
            )}
            {item.value ? (
              <span styleName="">
                {item.chgp > 0 ? `+${Number(item.chgp).toFixed(2)}` : Number(item.chgp).toFixed(2)}%
              </span>
            ) : (
              <span>No Data Available</span>
            )}
          </div>
        </a>
        {/* <button
          onClick={() => {
            checkUserLoggedIn(item);
            // eslint-disable-next-line no-unused-expressions
            loggedIn ? setBookmarked(true) : null;
          }}
          styleName="add-to-watchlist-btn"
          style={{
            background: bookmarked && 'var(--success-color)',
            borderColor: bookmarked && 'var(--success-color)'
          }}
        >
          <span styleName={bookmarked ? 'stock-added' : ''}>{bookmarked ? '✓' : '+'}</span>
        </button> */}
      </div>

      {stockNotification && (
        <Notification message={stockNotification} stockStatus={stockStatus} failure={failure} />
      )}
    </>
  );
};

Tile.propTypes = {
  item: objectOf(any).isRequired,
  checkUserLoggedIn: func,
  stockNotification: string,
  stockStatus: string,
  failure: bool,
  loggedIn: bool,
};

class MarketBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entities: [],
      selectedItem: '',
    };
  }

  componentDidMount() {
    const entityIds = this.props.entities
      .slice(0, 4)
      .map((entity) => entity.id)
      .join(',');
    this.getEntityDetails(entityIds);
    this.marketBoxRefreshInterval = setInterval(this.getEntityDetails.bind(this, entityIds), 60000);
  }

  componentWillUnmount() {
    if (this.marketBoxRefreshInterval) clearInterval(this.marketBoxRefreshInterval);
  }

  checkUserLoggedIn = (item) => {
    if (this.props.userLoggedIn) {
      this.addStockstoList(item);
    } else {
      this.setState({ selectedItem: item });
      // UserModal.open(this.updateMember, this.props.publicIntegrations, this.props.integrations);
      // use new piano login
    }
  };

  pianoLoggedInSuccess = (data) => {
    const { reloadMember } = this.props;
    reloadMember();
    // this.redirectTo();
  };

  pianoLoggedInFailed = (data) => {
    const { reloadMember } = this.props;
    reloadMember();
  };

  pianoLogout() {
    const { reloadMember } = this.props;
    reloadMember();
  }

  updateMember = async (member) => {
    await this.props.reloadMember(member);
    this.addStockstoList(this.state.selectedItem);
  };

  addStockstoList = (item) => {
    const {
      memberDetail,
      integrations: { piano = {} },
    } = this.props;
    const { aid } = piano;
    let token = null;

    if (item.type === 'index') {
      item.type = 'indices';
    }
    item.STOCKID = item.stockId || item.id;
    item.COMPNAME = item.name;
    let subscriptionStatus = '';
    this.props.showLoader();
    getSubscriptions(aid, token)
      .json((res) => {
        const { status } = res;
        if (status) {
          subscriptionStatus = 'active';
        }
        getWatchlist(memberDetail)
          .then((data) => {
            this.triggerGetAction(data.data);
            return data;
          })
          .then((data) => {
            const parsedData = data.data;
            const stocksIds = Object.keys(parsedData.stocks);
            if (stocksIds.find((stockid) => Number(stockid) === item.STOCKID)) {
              this.props.showNotification(
                `${item.COMPNAME} is already in your Watchlist &nbsp;<a target="_blank" rel="noopener noreferrer"href = "/my-account/my-watchlist" styleName="subscribe_link"><b>VIEW</b></a>`
              );
            } else {
              this.props
                .addEntity(item, this.props.maxStock, parsedData, subscriptionStatus)
                .catch(console.error);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  triggerGetAction = (data) => {
    this.props.getStocksFromFirebase(data);
  };

  getEntityDetails = (params) => {
    fetch(`/next/feapi/stock?entity-ids=${params}`)
      .then((response) => response.json())
      .then((entities) => this.setState({ entities }))
      .catch(() => this.setState({ entities: [] }));
  };

  render() {
    // const SLIDER_SETTINGS = {
    //   dots: false,
    //   infinite: this.state.entities.length > 3,
    //   speed: 1500,
    //   swipeToSlide: true,
    //   slidesToShow: 3,
    //   slidesToScroll: 1,
    //   autoplay: false,
    //   autoplaySpeed: 5000,
    //   centerMode: true,
    //   centerPadding: '30px',
    //   // arrows: false,
    //   nextArrow: (
    //     <div>
    //       <RightArrowSmall color="fourth-color" />
    //     </div>
    //   ),
    //   prevArrow: (
    //     <div>
    // {
    /*      <LeftArrowSmall color="fourth-color" /> */
    // }
    // {
    /*    </div> */
    // }
    //   ),
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         infinite: this.state.entities.length > 3,
    //         slidesToShow: 2,
    // {
    /*        centerPadding: '20px' */
    // }
    //       }
    //     },
    //     {
    //       breakpoint: 600,
    //       settings: {
    //         infinite: this.state.entities.length > 2,
    //         slidesToShow: 1,
    //         centerPadding: '20px'
    //       }
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         infinite: this.state.entities.length > 1,
    //         slidesToShow: 1,
    //         centerPadding: '15px'
    //       }
    //     }
    //   ]
    // };
    return this.state.entities.length ? (
      <div styleName={`container`}>
        {/* <div styleName="market-box-header">Stocks in the story</div> */}
        {this.state.entities.map((entity) => (
          <Tile
            item={entity}
            key={entity.name}
            stockNotification={this.props.stockNotification}
            checkUserLoggedIn={this.checkUserLoggedIn}
            stockStatus={this.props.stockStatus}
            failure={this.props.failure}
            loggedIn={this.props.userLoggedIn}
          />
        ))}
      </div>
    ) : (
      <div />
    );
  }
}

MarketBox.propTypes = {
  entities: arrayOf(object).isRequired,
  showLoader: func,
  addEntity: func,
  removeLoader: func,
  maxStock: object,
  getStocksFromFirebase: func,
  stockNotification: string,
  stocks: object,
  showNotification: func,
  userLoggedIn: bool,
  publicIntegrations: object.isRequired,
  integrations: object.isRequired,
  reloadMember: func,
  subscriptionStatus: string,
  stockStatus: string,
  failure: bool,
  memberDetail: object,
};

const mapStateToProps = (state) => {
  const { pianoUserDetails = {} } = state;
  const memberDetail = pianoUserDetails.member || {};
  const isUserValid = memberDetail.uid || null;
  return {
    maxStock: get(state, ['qt', 'config', 'features', 'stock_watchlist_tab', 'max_stock'], {}),
    stocks: get(state, ['userDetails', 'stockWatchList', 'stocks'], {}),
    stockNotification: get(state, ['userDetails', 'stockNotification'], null),
    userLoggedIn: !!isUserValid,
    subscriptionStatus: get(state, ['userDetails', 'subscriptionStatus'], null),
    publicIntegrations: state.qt.config['public-integrations'] || {},
    integrations: state.qt.config.integrations || {},
    stockStatus: get(state, ['userDetails', 'stockStatus'], null),
    failure: get(state, ['userDetails', 'failure'], null),
    memberDetail: memberDetail,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    getStocksFromFirebase: function (payload) {
      dispatch({
        type: BQ_STOCK_WATCHLIST_GET,
        payload: payload,
      });
    },
    addEntity: function (payload, maxStock, data, subscriptionStatus) {
      const maxAddStock =
        subscriptionStatus === 'active' ? maxStock.subscribed : maxStock.non_subscribed;
      if (size(data.stocks) + 1 > maxAddStock) {
        const message =
          props.subscriptionStatus !== 'active'
            ? 'You’ve added the maximum number of stocks permissible. &nbsp;<a target="_blank" rel="noopener noreferrer"href = "/bq-blue-subscription?utm_source=source-mybq,medium-watchlist,campaign–stock-exceed" styleName="subscribe_link"><b>Subscribe to add more</b></a>'
            : 'You have reached free stocks limit.';
        dispatch({
          type: BQ_STOCK_NOTIFICATIONS_SET,
          payload: {
            message: message,
          },
        });
        dispatch({
          type: BQ_NOTIFICATION_LIST,
          payload: {
            notification: setTimeout(() => {
              dispatch({ type: BQ_STOCK_NOTIFICATIONS_DISABLE });
            }, 3000),
          },
        });
        return Promise.resolve();
      }
      return addEntityToFirebase(payload.type, payload, data.memberId, data)
        .then(() => {
          dispatch({ type: BQ_ENTITY_WATCHLIST_ADD_FROM_STORY, payload: payload });
        })
        .then(() => {
          dispatch({
            type: BQ_NOTIFICATION_LIST,
            payload: {
              notification: setTimeout(() => {
                dispatch({ type: BQ_STOCK_NOTIFICATIONS_DISABLE });
              }, 3000),
            },
          });
        });
    },
    showNotification: (message) => {
      dispatch({
        type: BQ_STOCK_ALREADY_ADDED,
        payload: {
          message: [message],
        },
      });
      dispatch({
        type: BQ_NOTIFICATION_LIST,
        payload: {
          notification: setTimeout(() => {
            dispatch({ type: BQ_STOCK_NOTIFICATIONS_DISABLE });
          }, 3000),
        },
      });
    },
    showLoader: () => {
      dispatch({
        type: SHOW_LOADER,
      });
    },
    removeLoader: () => {
      dispatch({
        type: REMOVE_LOADER,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketBox);
